import React, { useEffect, useState } from 'react'

import Megafono from "assets/icons/megafono.png"
import Switch from 'react-bootstrap/esm/Switch'
import { ReactComponent as IconoMegafonoNaranja } from 'assets/icons/ParaSUconocimiento.svg';
import { ReactComponent as Advertencia } from 'assets/icons/ADVERTENCIA.svg';
import { ReactComponent as AdvertenciaTriangulo } from 'assets/icons/warningtriangle.svg';

import { ReactElement } from "react";


{/* <div>Iconos diseñados por <a href="https://www.freepik.com" title="Freepik">Freepik</a> from <a href="https://www.flaticon.es/" title="Flaticon">www.flaticon.es</a></div> */ }

export enum TiposAlerta {
    SOLICITUD_VACACIONES = 1,
    SOLICITUD_VACACIONES_ERROR = 4,
    PLANIFICACION_VACACIONES = 2,
    PLANIFICACION_VACACIONES_AVISO = 3,
    ADVERTENCIA = 5,
    PARA_CONOCIMIENTO = 6
}

export type PropsAlertNew = {
    mensaje: string,
    oncloseElement: () => void,
    mensajeHTML?: any,
    closeButton?: boolean,
    tipo?: TiposAlerta,
    cabeceraTitulo?: string,
    iconoAlerta?: any,
    classNameAdicional?: string
}

const AlertNew = (props: PropsAlertNew) => {


    const [idIconoAlerta, setidIconoAlerta] = useState<string>("");
    const [classNameAlerta, setclassNameAlerta] = useState<string>("");

    
    

    useEffect(() => {

        var timer = setInterval(() => {

            if (props.tipo == TiposAlerta.ADVERTENCIA) {
                setidIconoAlerta(prevIcono =>
                    prevIcono === "iconoAdvertenciaTrianguloEncendido" || prevIcono === ""
                        ? "iconoAdvertenciaTriangulo"
                        : "iconoAdvertenciaTrianguloEncendido"
                );

                setclassNameAlerta(prevClassName =>
                    prevClassName === "new-alert-advertencia-triangulo-enc" || prevClassName === ""
                        ? "new-alert-advertencia-triangulo"
                        : "new-alert-advertencia-triangulo-enc"
                );
            }
        } , 500); // Interval set to 2000 milliseconds (2 seconds)

        // Cleanup function to clear the interval when the component unmounts
        return () => clearInterval(timer);


    }, [])




    var classNameTipoAlerta = ""
    var classNameCuerpoAlerta = "cuerpo_alerta"
    var iconoAlerta: React.ReactElement | undefined = undefined;
    var mostrarCabecera = true;
    if (props.tipo !== undefined) {
        switch (props.tipo) {
            case TiposAlerta.SOLICITUD_VACACIONES:
                classNameTipoAlerta = "new-alert-vacaciones"
                iconoAlerta = <Advertencia id="iconoAdvertenciaMensaje" style={{ "fill": "none" }} />
                break;
            case TiposAlerta.SOLICITUD_VACACIONES_ERROR:
                classNameTipoAlerta = "new-alert-vacaciones-warning"
                iconoAlerta = <Advertencia id="iconoErrorMensaje" style={{ "fill": "none" }} />
                break;
            case TiposAlerta.PLANIFICACION_VACACIONES:
                classNameTipoAlerta = "new-alert-planificacion-vacaciones"
                iconoAlerta = <Advertencia id="iconoAdvertenciaMensaje" style={{ "fill": "none" }} />
                break;
            case TiposAlerta.PLANIFICACION_VACACIONES_AVISO:
                classNameTipoAlerta = "new-alert-planificacion-vacaciones2"
                iconoAlerta = undefined
                mostrarCabecera = false;
                break;
            case TiposAlerta.ADVERTENCIA:
                classNameTipoAlerta = classNameAlerta === "" ? "new-alert-advertencia-triangulo" : classNameAlerta
                const idIcono = idIconoAlerta === "" ? "iconoAdvertenciaTriangulo" :idIconoAlerta

                iconoAlerta = <AdvertenciaTriangulo id={idIcono} />
                classNameCuerpoAlerta = 'cuerpo-alert-advertencia-triangulo'
                break;
            case TiposAlerta.PARA_CONOCIMIENTO:
                classNameTipoAlerta = "new-alert-conocimiento"
                iconoAlerta =  <Advertencia id="iconoAdvertenciaMensaje" style={{ "fill": "none" }} />
                break;
            default:
                iconoAlerta = <img src={Megafono} className="icono_imagen " />
                break;
        }
    }



    return (
        <div className={`new-alert-warn mb-1 ${classNameTipoAlerta} ${props.classNameAdicional ?? ""}`}>
            {props.closeButton === undefined || (props.closeButton !== undefined && props.closeButton === true) && <a className="newCloseAlert" onClick={() => props.oncloseElement()}>&times;</a>}
            {
                mostrarCabecera &&
                <div className={`cabecera_alerta`}>
                    {iconoAlerta}
                    {props.cabeceraTitulo ?? "AVISO"}
                </div>
            }

            {
                props.mensaje && props.mensajeHTML === undefined && (
                    <div className={classNameCuerpoAlerta}> {props.mensaje} </div>
                )
            }
            {
                props.mensajeHTML !== undefined && (
                    <div className={classNameCuerpoAlerta}>
                        {props.mensajeHTML}
                    </div>
                )
            }

        </div>
    )
}

export default AlertNew;
